export const parseFileFromUrl = (text: string) => {
  try {
    const url = new URL(text);
    return url.pathname.split('/').pop()?.split('.') || [];
  } catch {
    return [];
  }
};
